<template>
  <div class="place-order">
    <!-- <Row :gutter="12" style="margin-bottom: 12px;">
      <Col span="24" v-if="cardData.dailyQuotaSettingResDtoList.length">
        <Card class="status-card containerLimit-card">
          <div class="card-header">
            <div><span class="rectangle"></span> 每日接单箱量额度</div> -->
            <!-- <Tooltip>b
              <i class="iconfont iconquestion"></i>
              <div slot="content">
                <p
                  style="min-width: 300px; font-size: 12px;"
                  v-html="cardData.showDto.dayQtyLimitShow"
                ></p>
              </div>
            </Tooltip> -->
          <!-- </div>
          <div class="card-body">
            <div
              class="card-content-item"
              v-for="(item, index) in cardData.dailyQuotaSettingResDtoList"
              :key="index"
            > -->
              <!-- 解开这段注释b -->
              <!-- <div v-if="item.portName != '上海港' && item.portName != '宁波港' && item.portName != '青岛港' && item.portName != '深圳港'">
                <div class="count-num">--</div>
                <div>{{ item.portName }}</div>
              </div> -->
              <!-- <div>
                <div class="count-num">{{ item.dayQtyLimit == 0 ? "---" : item.dayQtyLimit }}</div>
                <div>{{ item.portName }}</div>
              </div> -->
<!--              <div>b-->
<!--                <div class="count-num">无限制</div>-->
<!--                <div>{{ item.portName }}</div>-->
<!--              </div>-->
            <!-- </div>
          </div>
        </Card>
      </Col>
    </Row> -->
    <Card v-if="!isShowXiniyuan">
      <ContainerBalanceChart :default-port-ids="defaultPortIds" :port-option-list="portOptionList" ref="dayChart"/>
    </Card>
    <Card style="margin-top: 12px;" v-if="!isShowXiniyuan">
      <ContainerBalanceMonth
        ref="monthChart"
        :default-port-ids="defaultPortIds"
        :port-option-list="portOptionList"
      />
    </Card>
    <Card style="margin-top: 12px;" v-if="!isShowXiniyuan">
      <Row :gutter="12" style="margin: 0">
        <FeeConfirmChart />
      </Row>
    </Card>
    <!-- 逾期图表 -->
    <Card style="margin-top: 12px;" v-if="!isShowXiniyuan">
      <Row :gutter="12" style="margin: 0">
        <MonthlyBillChart />
      </Row>
    </Card>
    <!-- <Row :gutter="12" style="margin-top: 12px;">
      
      <Col span="24" v-if="cardData.containerBalanceList.length">
        <Card class="status-card containerBalance-card">
          <div class="card-header">
            <div><span class="rectangle"></span> 箱平衡</div>
            <Tooltip placement="left" transfer>
              <i class="iconfont iconquestion"></i>
              <div slot="content">
                <p
                  style="min-width: 300px; font-size: 12px;"
                  v-html="cardData.showDto.containerBalanceShow"
                ></p>
              </div>
            </Tooltip>
          </div>
          <div class="card-body">
            <div
              class="card-content-item"
              v-for="(item, index) in cardData.containerBalanceList"
              :key="index"
            >
              <div class="flex-center-v" style="margin-bottom: 6px;">
                <span
                  >{{ item.portName }}目标箱平衡&nbsp;&nbsp;&nbsp;&nbsp;</span
                >
                <span class="big-font">{{
                  item.standardCoefficient | placeholder
                }}</span>
              </div>
              <div class="flex-center-v">
                <span
                  >{{ item.portName }}当前箱平衡&nbsp;&nbsp;&nbsp;&nbsp;</span
                >
                <span
                  class="big-font"
                  :class="[
                    conBalanceColorClass(
                      item.customerCoefficient - item.standardCoefficient
                    ),
                    [null, undefined, ''].includes(item.customerCoefficient)
                      ? 'text-black'
                      : '',
                  ]"
                  >{{ item.customerCoefficient | placeholder }}</span
                >
              </div>
            </div>
          </div>
        </Card>
      </Col>
    </Row> -->

    <Row :gutter="12" style="margin-top: 12px;">
      <Col span="9">
        <Card class="status-card">
          <div class="card-header">
            <div><span class="rectangle"></span> 可用额度</div>
            <Tooltip transfer>
              <i class="iconfont iconquestion"></i>
              <div slot="content">
                <p
                  style="min-width: 300px; font-size: 12px;"
                  v-html="cardData.availableCreditShow"
                ></p>
              </div>
            </Tooltip>
          </div>
          <div class="card-body">
            <div class="card-content-item">
              <div
                v-for="(item,index) in cardData.companyCredits" :key="index"
                class="big-font"
                :class="[
                  item.availableAmount <= 0
                    ? 'text-red'
                    : 'text-green',
                ]"
                >{{ spliceCurrencySymbolAndCost(item.currency,item.availableAmount) }}</div
              >
            </div>
          </div>
        </Card>
      </Col>
      <Col span="15" v-if="cardData.overDurBillInfoStatistics && cardData.overDurBillInfoStatistics.overDurBillInfoList.length">
        <Card class="status-card">
          <div class="card-header">
            <div><span class="rectangle"></span> 逾期账款</div>
          </div>
          <div class="card-body">
            <div class="card-content-item">
              逾期账单周期: {{ cardData.overDurBillInfoStatistics.toDate }},
              &nbsp;&nbsp;&nbsp;&nbsp; 共计逾期未核销金额
              <p v-for="item in cardData.overDurBillInfoStatistics.overDurBillInfoList" class="text-red">{{ spliceCurrencySymbolAndCost(item.currency,item.amount) }}</p>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
    <div class="footer">
      <template v-if="$route.name === 'place-order-index' && (isShowBtn || done)" >
        <Button
          type="primary"
          style="margin-right: 20px;"
          @click="handleRouterGo('main-query-charge_index')"
          v-if="!isShowXiniyuan"
          >新门点下单</Button
        >
        <Button
          @click="handleRouterGo('create-history-order')"
          style="color: #ff9100;margin-right: 20px;"
          >老门点下单</Button
        >
        <Button @click="uploadModal.show = true" style="color: #ff9100;" v-if="showUploadDocumentTemplate">托书模板上传</Button>
        <!-- 询价 -->
        <!-- 老门点 -->
      </template>
      <template v-else-if="$route.name === 'place-order-pre' && (isShowBtn || done)">
        <!-- 继续下单 -->
        <Button type="primary" @click="handleRouterGo(orderPath)"
          >继续下单</Button
        >
      </template>
    </div>
    <BillCheckModal ref="billCheckModal" @place-order="onPlaceOrder" />
    <Modal
        class="upload-modal"
        v-model="uploadModal.show"
        title="上传托书"
        :mask-closable="false"
      >
        <Upload
          ref="upload"
          :multiple="false"
          :headers="headersObj"
          :max-size="10240"
          :before-upload="handleUpload"
          type="drag"
          action="/ws-truck/duckBill/uploadDocumentTemplate/createOrder"
        >
          <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>点击或将文件拖拽到这里上传</p>
            <p>支持扩展名：.txt</p>
            <p>文件最大不能超过 10M</p>
          </div>
        </Upload>
        <div v-if="uploadTxt.name">
          {{uploadTxt.name}}
          <Icon type="close-round" style="float:right" @click="uploadTxt = {name:null}"></Icon>
        </div>
        <div slot="footer" style="text-align: center">
          <Button
            @click="uploadModal.show = false"
          >关闭</Button>
          <Button
            type="primary"
            :loading="btnLoading"
            @click="handleConfirm"
          >确认</Button>
        </div>
      </Modal>
      <remind ref="remind" @hideRemind="hideRemind" />
  </div>
</template>

<script>
import _ from "lodash";
import Cookies from 'js-cookie';
import { mapGetters } from "vuex";
import CollapsePanel from "./collapse-panel";
import ContainerBalanceChart from "../container-balance-chart";
import ContainerBalanceMonth from "./container-balance-month";
import FeeConfirmChart from "./fee-confirm-chart";
import MonthlyBillChart from "./monthly-bill-chart";
import BillCheckModal from "@/components/bill-check-modal";
import {
  fetchPlaceOrderData,
  fetchContainerPortAndNum,
  uploadDocumentTemplate,
  querySnapshot
} from "@/api/containerBalance";
import dayjs from "dayjs";
import util from "@/libs/util";
import remind from "@/components/new-register/remind.vue"
import win from "global";
// #c3291c¡
// #8ce2c3
let routeParams = {};
export default {
  components: {
    CollapsePanel,
    ContainerBalanceChart,
    ContainerBalanceMonth,
    BillCheckModal,
    FeeConfirmChart,
    MonthlyBillChart,
    remind
  },
  async created() {
    routeParams = JSON.parse(JSON.stringify(this.$route.params));
    const portListResp = await fetchContainerPortAndNum({
      startDate:this.genDateRange()[0],
      endDate: this.genDateRange()[3]
    });
    const portList = portListResp.map((v) => v.portId);
    const { name } = this.$route;
    this.cardData.dailyQuotaSettingResDtoList = []
    if (name === "place-order-index") {
      // 下单页面, 全选港口   2020-8-24  默认勾选4周内单量最多的港口
      
      this.defaultPortIds[0] = _.cloneDeep(portList[0]);
      fetchPlaceOrderData({
        portId: null,
      }).then((res) => {
        this.cardData = res;
        console.log('this.cardData',this.cardData)
        // let portArr = ['上海港','宁波港','青岛港','深圳港']
        // let newArr = []
        // console.log('this.cardData.dailyQuotaSettingResDtoList',this.cardData.dailyQuotaSettingResDtoList)
        // portArr.forEach(item => {
        //   this.cardData.dailyQuotaSettingResDtoList.forEach(initem => {
        //     if (item == initem.portName) {
        //       newArr.push(initem)
        //     }
        //   })
        // })
        // this.cardData.dailyQuotaSettingResDtoList = newArr
        // console.log('----------this.cardData.dailyQuotaSettingResDtoList',this.cardData.dailyQuotaSettingResDtoList)
      });
    } else if (name === "place-order-pre") {
      if(this.$route.query.priceSnapshotId) {
        const res = await querySnapshot({priceSnapshotId: this.$route.query.priceSnapshotId})
        const req = res.data.data.priceData.req
        console.log('0000000000000000',req);
        sessionStorage.setItem("PortId", req.portId)
        routeParams = {
          boundTypeId: req.boundTypeId,
          containerSize: req.containerSize,
          doorAddressList: req.locationList,
          doorArea: res.data.data.priceData.entityAreaInfoDto.doorArea,
          doorAreaId: res.data.data.priceData.entityAreaInfoDto.id,
          orderTypeInfo:  {
            containerSize: req.containerSize,
            priceType: this.$route.query.priceType,
            // route: "苏高新→外港",
            route: this.$route.query.transitPointId,
            subTransportTypeName: this.$route.query.subTransportTypeName,
            transitPointId: this.$route.query.transitPointId,
            transitPointName: this.$route.query.transitPointName.split('码头')[0],
            transportTypeId: this.$route.query.transportTypeId
          },
          portDistricts: req.pricingPortDistrictId,
          portId: req.portId,
          priceType: this.$route.query.priceType,
          transportTypeId: this.$route.query.transportTypeId
        }
        console.log(33333333, req.pricingPortDistrictName, req.portId, this.$route.query.subTransportTypeName, this.$route.query.transitPointName.split('码头')[0]);
        this.etdArr.forEach(e => {
          if (req.pricingPortDistrictName && req.pricingPortDistrictName.includes(e.pricingPortDistrictName)  &&
              req.portId.includes(e.portId) &&
              this.$route.query.subTransportTypeName && this.$route.query.subTransportTypeName.includes(e.subTransportTypeName) &&
              this.$route.query.transitPointName.split('码头')[0].includes(e.transitPointName) 
          ){
            routeParams.orderTypeInfo.route = e.route
          }
        });
        console.log(22222222222222, routeParams);
      }
      // 下单提示页面, 选择暂存的港口

      // 查运价
      const portId = sessionStorage.getItem("PortId");
      if (portId) {
        this.defaultPortIds = [portId];
        // this.portOptionList = [{ portId, portName: this.portMap[portId] }];
        this.portOptionList = portListResp
        console.log('portListResp',portListResp)
        if(JSON.stringify(portListResp).indexOf(portId) < 0){
          this.portOptionList.push({ portId, portName: this.portMap[portId] })
        }
        this.orderPath = "create-detail-order";
      } else {
        // 上传托书
        this.defaultPortIds = _.cloneDeep(portList[0]);
        this.orderPath = "create-order";
      }

      fetchPlaceOrderData({
        portId: portId,
      }).then((res) => {
        this.cardData = res;
        // console.log('--------------------',this.cardData)
        // let portArr = ['上海港','宁波港','青岛港','深圳港']
        // let newArr = []
        // portArr.forEach(item => {
        //   this.cardData.dailyQuotaSettingResDtoList.forEach(initem => {
        //     if (item == initem.portName) {
        //       newArr.push(initem)
        //     }
        //   })
        // })
        // this.cardData.dailyQuotaSettingResDtoList = newArr
        // console.log('----------newArr',newArr)
      });
    }
    if (!this.isShowXiniyuan){
      this.$refs.dayChart.addWatcher()
      this.$refs.monthChart.addWatcher()
    }
    this.uploadDocumentTemplateCheck()
  },
  data() {
    return {
      btnLoading:false,
      headersObj: {
        'X-Requested-By': 'eshipping'
      },
      uploadModal:{
        show : false
      },
      showWeekChart: false,
      defaultPortIds: [],
      cardData: {
        containerBalanceList: [], // 箱平衡
        dailyQuotaSettingResDtoList: [], // 箱量额度
        companyCredits: {},//授信额度相关
        overDurBillInfo: {},
        showDto: {
          containerBalanceShow: "",
          dayQtyLimitShow: "",
        },
      },
      orderPath: "",
      curClickRouteName: "",
      portOptionList: [],
      showUploadDocumentTemplate: false,
      uploadTxt: {
        name:''
      },
      isShowXiniyuan:Cookies.get('isVest') == 'true' ? true : false,
      getDate:null,
      etdArr:[
        {pricingPortDistrictName:"洋山",portId:"SHANGHAI",subTransportTypeName:"直达",transitPointName:"独山",etd:"ETD-4天",route:"独山→洋山"},
        {pricingPortDistrictName:"外港",portId:"SHANGHAI",subTransportTypeName:"中转",transitPointName:"独山",etd:"ETD-5天",route:"独山→洋山→外港"},
        {pricingPortDistrictName:"北仑",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"港吉",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"远东",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"四期",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"大榭",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"梅山",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"甬舟",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"舟山综合保税区",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"镇海",portId:"NINGBO",subTransportTypeName:"直达",transitPointName:"乍浦",etd:"ETD-5天",route:"乍浦→宁波"},
        {pricingPortDistrictName:"洋山",portId:"SHANGHAI",subTransportTypeName:"中转",transitPointName:"苏高新",etd:"ETD-7天",route:"苏高新→太仓/外港→洋山"},
        {pricingPortDistrictName:"洋山",portId:"SHANGHAI",subTransportTypeName:"直达",transitPointName:"苏高新",etd:"ETD-5天",route:"苏高新→洋山"},
        {pricingPortDistrictName:"外港",portId:"SHANGHAI",subTransportTypeName:"直达",transitPointName:"苏高新",etd:"ETD-5天",route:"苏高新→外港"},
        {pricingPortDistrictName:"洋山",portId:"SHANGHAI",subTransportTypeName:"直达",transitPointName:"苏华",etd:"ETD-5天",route:"苏华→洋山"},
        {pricingPortDistrictName:"外港",portId:"SHANGHAI",subTransportTypeName:"直达",transitPointName:"苏华",etd:"ETD-5天",route:"苏华→外港"},
        {pricingPortDistrictName:"洋山",portId:"SHANGHAI",subTransportTypeName:"中转",transitPointName:"苏华",etd:"ETD-7天",route:"苏华→太仓/外港→洋山"},
        {pricingPortDistrictName:"北仑",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"港吉",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"远东",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"四期",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"大榭",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"梅山",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"甬舟",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"舟山综合保税区",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"镇海",portId:"NINGBO",subTransportTypeName:"中转",transitPointName:"德清",etd:"ETD-6天",route:"德清→乍浦→宁波"},
        {pricingPortDistrictName:"外港",portId:"SHANGHAI",subTransportTypeName:"直达",transitPointName:"连云港",etd:"ETD-6天",route:"连云港->外港"},
        {pricingPortDistrictName:"洋山",portId:"SHANGHAI",subTransportTypeName:"直达",transitPointName:"连云港",etd:"ETD-6天",route:"连云港->洋山"},
      ],
    };
  },
  watch:{
    "uploadModal.show": {
      handler(v) {
        if(!v){
          this.uploadTxt = {name:null}
          this.btnLoading = false
        }
      },
      deep: true,
    },
  },
  methods: {
    // 上传托书模板检测
    uploadDocumentTemplateCheck(){
      util.ajax_post(this, '/ws-truck/duckBill/uploadDocumentTemplate/check',{}, res => {
        this.showUploadDocumentTemplate = res.data.success
    	})
    },
    handleUpload(file){
      if (file.type != 'text/plain'){
        this.$Message.error('请选择.txt文件上传')
      }else {
        this.uploadTxt = file
      }
      return false;
    },
    handleConfirm(){
      if (!this.uploadTxt.name){
        this.$Message.error('请选择.txt文件上传')
        return
      }
      this.btnLoading = true
      let formData = new FormData()
      formData.append('file',this.uploadTxt)
      uploadDocumentTemplate(formData).then(res=>{
        console.log(res)
        if (res.data.success){
          this.uploadTxt = {
            name: null
          }
          this.uploadModal.show = false
          this.$Message.success('下单成功')
        }else {
          this.$Message.error(res.data.message)
        }
        this.btnLoading = false
      }).catch(res=>{
        this.$Message.error('上传失败,请重新选择文件')
        this.btnLoading = false
      })
    },
    genDateRange() {
      let num = 27;
      let unit = "day";
      const now = dayjs();
      const prevEndDate = now;
      const prevStartDate = now.subtract(num, unit);
      const curWeekStartDate = now.add(1, "day");
      const curWeekEndDate = now.add(7, "day");
      return [
        prevStartDate,
        prevEndDate,
        curWeekStartDate,
        curWeekEndDate,
      ].map((v) =>
        v
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0)
          .format("YYYY-MM-DD")
      );
    },
    hideRemind(data){
      this.curClickRouteName = data.data;
      this.$refs.billCheckModal.showCheckBill();
    },
    handleRouterGo(path) {
      this.$refs.remind.show(path)
    },
    /**
     * @desc 对路由栈进行匹配
     */
    matchRouteName() {
      const routeStack = JSON.parse(
        sessionStorage.getItem("RouteStack") || "[]"
      );
      const len = routeStack.length;
      if (len < 2) return null;
      // 倒叙遍历
      for (let index = len - 1; index >= 1; index--) {
        const ele = routeStack[index];
        const prevEle = routeStack[index - 1];
        if (
          ele.name === "place-order-pre" &&
          ["/main-query-charge/index", "/order-booking/index"].includes(
            prevEle.path
          )
        ) {
          // 找到符合的 pair
          return prevEle;
        }
      }
    },
    conBalanceColorClass(value) {
      if (value > 0) {
        return "text-green";
      } else if (value === 0) {
        return null;
      } else {
        return "text-red";
      }
    },
    onPlaceOrder() {
      console.log(1111111111111111111111111, routeParams);
      let path = this.curClickRouteName;
      this.$router.push({
        name: path,
        params: this.$route.name === "place-order-pre" ? routeParams : {},
        query: {
          from:
            this.$route.name === "place-order-index"
              ? "place-order-index"
              : null,
        },
      });
    },
    spliceCurrencySymbolAndCost(currency,price){
      return util.spliceCurrencySymbolAndCost(currency,price)
    },
  },
  filters: {
    placeholder(value) {
      if ([null, undefined, ""].includes(value)) {
        return "暂无";
      } else {
        return value;
      }
    },
  },
  computed: {
    ...mapGetters("data", ["portMap"]),
    isShowBtn(){
      let flag 
      if(this.$store.state.user.needCertification && this.$store.state.user.companyCertificationStatus != 'Verify' && this.$store.state.user.certificationDate < 1){
        flag = false
      }else {
        flag = true
      }
      return flag
    },
    done(){
     return  this.$store.state.user.done
    }
  }
};
</script>

<style lang="less" scoped>
.rectangle {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #f09537;
}
.place-order {
  padding: 12px;
  padding-top: 4px;
  .text-red {
    color: red;
  }
  .text-green {
    color: #6be6c1;
  }
  span.text-black {
    color: unset;
    font-size: 26px;
    transform: scale(0.75);
    transform-origin: left center;
  }
}
.status-card {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      font-weight: 500;
      font-size: 16px;
    }
    i {
      cursor: pointer;
      font-size: 20px;
    }
  }
  .card-body {
    padding-left: 14px;
  }
  .card-content-item {
    min-height: 60px;
  }
  .flex-center-v {
    display: inline-flex;
    align-items: center;
  }
  .big-font {
    font-weight: 600;
    font-size: 26px;
  }
}
.containerLimit-card {
  .card-body {
    display: flex;
  }
  .card-body .card-content-item {
    padding: 10px 0;
    text-align: center;
    border-right: 1px solid #eee;
    flex-grow: 2;
    &:last-child {
      border-right: none;
    }
    .count-num {
      // font-size: 30px;
      font-size: 20px;
      line-height: 45px;
      font-weight: 600;
      margin-bottom: 18px;
    }
  }
}
.containerBalance-card {
  .card-body {
    display: flex;
  }
  .card-body .card-content-item {
    max-width: 40%;
    display: inline-flex;
    flex-grow: 1;
    justify-content: center;
    // align-items: center;
    flex-direction: column;
    min-height: 104px;
    padding: 10px 0;
    padding-left: 10%;
    text-align: center;
    border-right: 1px solid #eee;
    max-width: 40%;
    background: #f6fafe;
  }
}
.place-order .footer {
  margin-top: 20px;
  text-align: center;
  button.ivu-btn-primary {
    background-color: #ff9100;
    border-color: #ff9100;
    width: 120px;
  }
  button.ivu-btn {
    border-color: #ff9100;
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// place-order.vue?511c7440